import { Alert } from 'antd'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

import { HistoryTimeline } from '@/Ship/Components/History'

import { ACTIVITY_HISTORY_EVENT_MAP } from '../Contracts/ActivityHistoryEvent'
import { buildActivityHistoryEntries } from '../Helpers/activityHistoryEntries'
import { ActivityHistoryTabStore } from '../Stores/ActivityHistoryTabStore'

/**
 * Вкладка «Історія змін» справи (ADR 041, `SPEC-011` §6, К-3) — остання
 * вкладка картки. Шаблон перемонтовує її ключем-«епохою» на кожне відкриття:
 * antd тримає вкладку змонтованою, і без цього щойно збережена зміна
 * лишилася б невидимою.
 */
export const ActivityHistoryTab = observer(({ uuid }: { uuid: string }) => {
    const [store] = useState(() => new ActivityHistoryTabStore())

    useEffect(() => {
        void store.load(uuid)
    }, [store, uuid])

    if (store.failed) {
        return <Alert type="error" showIcon title="Не вдалося завантажити історію змін." />
    }

    const hidden = store.total - store.items.length

    return (
        <HistoryTimeline
            entries={buildActivityHistoryEntries(store.items, ACTIVITY_HISTORY_EVENT_MAP)}
            loading={store.isLoading}
            {...(hidden > 0 ? { note: `Показано останні ${store.items.length} подій із ${store.total}` } : {})}
        />
    )
})
